import { parse, format, parseISO } from "date-fns";
import { VenueDetails } from "../types";

export function numberToName(num: number): string {
  const names = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
    "Twenty",
  ];

  if (num < 1 || num > 20) {
    return "ERR";
  }

  return names[num];
}

export function capitalizeFirstLetter(str: string): string {
  if (str.length === 0) return str; // Check if the string is empty
  return str.trimStart().charAt(0).toUpperCase() + str.trimStart().slice(1);
}

export function formatDateShort(input: string): string {
  try {
    if (input === "") return input; // Check if the string is empty
    // Parse the input string into a Date object
    const parsedDate = parse(input.split(" ")[0], "dd-MM-yyyy", new Date());

    // Format the Date object into the desired format
    const formattedDate = format(parsedDate, "MMM yyyy");

    return formattedDate;
  } catch (error) {
    console.log(error);
    return input;
  }
}

export function formatDate(input: string): string {
  try {
    if (input === "") return input; // Check if the string is empty
    // Parse the input string into a Date object
    const parsedDate = parse(input.split(" ")[0], "dd-MM-yyyy", new Date());

    // Format the Date object into the desired format
    const formattedDate = format(parsedDate, "dd MMMM yy");

    return formattedDate;
  } catch (error) {
    console.log(error);
    return input;
  }
}

export function formatFullDate(input: string): string {
  try {
    if (input === "") return input; // Check if the string is empty
    // Parse the input string into a Date object
    const parsedDate = parseISO(input);
    // Format the Date object into the desired format
    const formattedDate = format(parsedDate, "dd MMMM yyyy");

    return formattedDate;
  } catch (error) {
    console.log(error);
    return input;
  }
}

export function formatFullDateAsShort(input: string): string {
  try {
    if (input === "") return input; // Check if the string is empty
    // Parse the input string into a Date object
    const parsedDate = parseISO(input);
    // Format the Date object into the desired format
    const formattedDate = format(parsedDate, "MMM yyyy");

    return formattedDate;
  } catch (error) {
    console.log(error);
    return input;
  }
}

export function findImageByName(name: string | undefined | null, businessTypeData: any[] | undefined | null): string | null {
  // Return null if either input is undefined/null
  if (!name || !businessTypeData || !Array.isArray(businessTypeData)) {
    return null;
  }

  try {
    // Standardize the input name and names in the data by replacing spaces with underscores
    const standardizedInputName = name.replace(/\s+/g, "_").toLowerCase();

    // Find the object in the data array that matches the given name, standardizing each name before comparison
    const businessType = businessTypeData.find(
      (b: any) => b?.name && b.name.replace(/\s+/g, "_").toLowerCase() === standardizedInputName
    );

    // If an object is found, return its image property; otherwise, return null
    return businessType?.image || null;
  } catch (error) {
    console.error('Error in findImageByName:', error);
    return null;
  }
}

export function findCategoryImageByName(
  name: string,
  filterAccessibilityData: any,
  isDark: boolean
): string {
  // Standardize the input name and names in the data by replacing spaces with underscores
  const standardizedInputName = name.replace(/\s+/g, "_").toLowerCase();

  // Find the object in the data array that matches the given name, standardizing each name before comparison
  const category = filterAccessibilityData.find(
    (b: any) =>
      b.name.replace(/\s+/g, "_").toLowerCase() === standardizedInputName
  );

  // If an object is found, return its image property; otherwise, return a default value or null
  return category ? (isDark ? category.image_selected : category.image) : null;
}

export const isBasicVenue = (venueDetails?: VenueDetails) => {
  return ((venueDetails?.templateType === "Basic" || venueDetails?.templateType === "") && venueDetails.isPublicTemplate === "Yes");
};

export const isHybridVenue = (venueDetails?: VenueDetails) => {
  return (venueDetails?.templateType !== "Basic" && venueDetails?.isPublicTemplate === "Yes" );
};
